export default __webpack_public_path__ + "static/media/vl2_cropped.7da1ae12.png";